import { Header, Variant } from './Header'
import { StatusPanelGrid } from './StatusPanelGrid'
import { StatusIcon } from './status-icon/StatusIcon'
import { SupplyAvailabilityStatus } from '@/features/sparklend/common/data/market-info/reserve-status'

interface EmptyStatusPanelProps {
  status: SupplyAvailabilityStatus
  variant: Variant
}

export function EmptyStatusPanel({ status, variant }: EmptyStatusPanelProps) {
  return (
    <StatusPanelGrid>
      <StatusIcon status={status} />
      <Header status={status} variant={variant} />
    </StatusPanelGrid>
  )
}
